import clsx from 'clsx';
import styles from './Card.module.css';

/** @typedef {import('../types').SurfaceToken} SurfaceToken */

/**
 * @typedef {Object} CardOwnProps
 * @property {SurfaceToken} [surface='raised'] - Background, from the semantic surface token scale.
 * @property {import('react').ElementType} [as='div'] - Element/component to render as.
 * @property {import('react').ReactNode} children
 */

/** @typedef {CardOwnProps & Omit<import('react').HTMLAttributes<HTMLElement>, 'children'>} CardProps */

/**
 * @param {CardProps} props
 */
const Card = ({ as: Component = 'div', surface = 'raised', className, style, children, ...rest }) => {
    const mergedStyle = {
        ...style,
        background: `var(--color-surface-${surface})`,
    };

    return (
        <Component className={clsx(styles.vecCard, className)} style={mergedStyle} {...rest}>
            {children}
        </Component>
    );
};

export default Card;
